export const MAX_NUMBER_OF_DOCUMENTS = 10
export const MAX_NUMBER_OF_SCREENSHOTS = 10
export const MAX_NUMBER_OF_SCREENSHOTS_FREE_PLAN = 6
export const MAX_SCREENSHOT_MB_SIZE = 50
export const DOCUMENT_NAME_MIN_LENGTH = 3
export const DOCUMENT_NAME_MAX_LENGTH = 80
export const DOCUMENT_MAX_FILE_MB_SIZE = 10
export const DOCUMENT_MAX_THUMBNAIL_FILE_MB_SIZE = 10
